import { Component, Input } from "@angular/core"

@Component({
    selector: "flow-loader",
    templateUrl: "./flow-loader.component.html",
    styleUrls: ["./flow-loader.component.scss"],
    standalone: false,
})
export class FlowLoaderComponent {
  @Input() color: "light" | "dark" | "accent" = "light"
  @Input() size: "small" | "medium" | "large" = "medium"
  @Input() customColor: string = ""
  @Input() customSize: string = ""

  getStyles(): Record<string, string> {
    const styles: Record<string, string> = {}
    if (this.customColor) styles["borderColor"] = this.customColor
    if (this.customSize) {
      styles["width"] = this.customSize
      styles["height"] = this.customSize
    }
    return styles
  }
}
